export default {
  tempsRetrieveState: 'in-progress',
  downloadExcelState: 'ok',
  tempsRetrieveRecords: []
}
